
import React, { useEffect, useState } from "react";
import {
    Button, Tooltip, Switch, Empty, Breadcrumb, Menu, Dropdown
} from "antd";
import {
    ArrowLeftOutlined, CaretRightOutlined, CaretDownOutlined, DownOutlined, DownloadOutlined, FolderFilled
} from "@ant-design/icons";
import { useDispatch, useSelector } from "react-redux";
import domtoimage from "dom-to-image";
import { useRef } from "react";
import jsPDF from "jspdf";
import { accessShowZero, createPromise, folderStyle, whiteSpaceInternalAccess } from "../../../../utils/MainHelper";
import { downloadSummaryCSV, getSelectedAnalysis } from "../../../../utils/oneintelligence/OneIntelligenceHelper";
import { setGenerateGridData, setWhitespaceSegmentSizes } from "../../../../store/components/Reports.slice";
import { clearWhiteSpaceChartPDF } from "../../../../store/components/ReportBuilder.slice";
import CustomLayout from "../../../General/CustomLayout/CustomLayout";
import TableSkeleton from "../../../General/skeleton/TableSkeleton";
import CustomTable from "../../../../customcomponents/customtable/CustomTable";
import WhiteSpaceSummaryDisplay from "../WhiteSpaceSummaryWithText/WhiteSpaceSummaryDisplay";
import WhiteSpaceChartsDisplay from "../WhiteSpaceCharts/WhiteSpaceChartsDisplay"


const actionList = [
    {
        label: "CSV",
        key: "summarycsv",
        icon: <DownloadOutlined />,
        if: ["summary"]
    },
    {
        label: "PDF",
        key: "dlpdf",
        icon: <DownloadOutlined />,
        if: ["charts"]
    },
    {
        label: "PNG",
        key: "dlpng",
        icon: <DownloadOutlined />,
        if: ["charts"]
    },
    {
        label: "JPEG",
        key: "dljpeg",
        icon: <DownloadOutlined />,
        if: ["charts"]
    }
];

function GenerateGrid() {
    const dispatch = useDispatch();
    const chartRef = useRef();
    const [showVisualMode, setShowVisualMode] = useState("grid");
    const [showVisual, setShowVisual] = useState(false);
    const [isLoadingCharts, setIsLoadingCharts] = useState(false);
    const [downloading, setDownloading] = useState(false);
    const [disabledDownload, setDisabledDownload] = useState(true);
    const [showZeroInChart, setShowZeroInChart] = useState(true);
    const [breadItems, setBreadItems] = useState([]);
    const [expandedKeys, setExpandedKeys] = useState([]);
    const [columns, setColumns] = useState([]);
    const [displayData, setDisplayData] = useState([]);
    const [paginationConfig, setPaginationConfig] = useState({
        pageNumber: 1,
        itemsInPage: 50
    });
    const { generateGrid, reportIsLoading } = useSelector((state) => state.reports);
    const { mode } = useSelector((state) => state.reportBuilder);

    const onChangePagination = (page, rows) => {
        setPaginationConfig({
            pageNumber: page,
            itemsInPage: rows
        });
    };
    const pushItemInBreadCrumbs = (obj) => {
        setBreadItems((state) => {
            const newList = [...state]
            newList.push(obj)
            return newList
        })
    }

    const removeOtherItemInBreadCrumbs = (givenKey) => {
        setBreadItems((state) => {
            const newList = [];
            [...state].find((prev) => {
                newList.push(prev)
                if (prev.key === givenKey) return prev
            })
            return newList
        })
    }

    const chartsBreadPushObj = () => {
        const breadKey = "Charts"
        pushItemInBreadCrumbs({
            key: breadKey,
            title: breadKey,
        })
    }

    const summaryBreadPushObj = () => {
        const breadKey = "Summary"
        pushItemInBreadCrumbs({
            key: breadKey,
            title: breadKey,
            onClick: () => {
                if (showVisualMode !== "grid") {
                    runLoadingCharts();
                }
                setShowVisualMode("summary")
                removeOtherItemInBreadCrumbs(breadKey)
            }
        })
    }

    const gridBreadPushObj = () => {
        const breadKey = "Grid"
        pushItemInBreadCrumbs({
            key: breadKey,
            title: breadKey,
            onClick: () => {
                setShowVisualMode("grid")
                removeOtherItemInBreadCrumbs(breadKey)
            }
        })
    }

    const isClient = !whiteSpaceInternalAccess();

    useEffect(() => {
        if (isClient) {
            // setShowVisualMode("summary")
            // summaryBreadPushObj();
            setShowVisualMode("charts")
            chartsBreadPushObj();
        } else {
            setShowVisualMode("grid")
            gridBreadPushObj()
        }
    }, [isClient]);

    useEffect(() => {
        setDisabledDownload(true);
    }, [mode]);
    useEffect(() => {
        if (generateGrid.length) {
            const brandcols = {
                key: "brandparent",
                title: <i>Brands Score</i>,
                children: []
            };
            const genericscols = {
                key: "genericparent",
                title: <i>Generics Score</i>,
                children: [],
                className: "bodered-col"
            };
            // eslint-disable-next-line camelcase
            const brandcols_ranked = {
                key: "brandparent",
                title: <i>Brands Ranked</i>,
                children: [],
                className: "bodered-col"
            };
            // eslint-disable-next-line camelcase
            const genericscols_ranked = {
                key: "genericparent",
                title: <i>Generics Ranked</i>,
                children: [],
                className: "bodered-col"
            };
            const columnsTemp = [{
                title: "Candidate Whitespace",
                key: "name",
                fixed: "left",
                width: 200
            }];

            columnsTemp.push(brandcols);
            columnsTemp.push(brandcols_ranked);
            columnsTemp.push(genericscols);
            columnsTemp.push(genericscols_ranked);

            const averageObjRaw = {
                key: "average_raw",
                title: <i>Average Raw</i>,
                children: [],
                className: "bodered-col"
            };
            averageObjRaw.children.push({
                title: <b>Brands</b>,
                key: "avebrands_raw",
                align: "center",
                width: 100,
                render: (val, row) => <span className="avebrands-column" title={row.avebrands_raw}>{(row.avebrands_raw || 0).toFixed(2)}</span>,
                className: "bodered-col"
            });
            averageObjRaw.children.push({
                title: <b>Generics</b>,
                key: "avegenerics_raw",
                align: "center",
                width: 100,
                render: (val, row) => <span className="avegenerics-column" title={row.avegenerics_raw}>{(row.avegenerics_raw || 0).toFixed(2)}</span>
            });

            const averageObj = {
                key: "average",
                title: <i>Average Ranked</i>,
                children: [],
                className: "bodered-col"
            };

            averageObj.children.push({
                title: <b>Brands</b>,
                key: "avebrands",
                align: "center",
                width: 100,
                render: (val, row) => <span className="avebrands-column" title={row.avebrands}>{(row.avebrands || 0).toFixed(2)}</span>,
                className: "bodered-col"
            });
            averageObj.children.push({
                title: <b>Generics</b>,
                key: "avegenerics",
                align: "center",
                width: 100,
                render: (val, row) => <span className="avegenerics-column" title={row.avegenerics}>{(row.avegenerics || 0).toFixed(2)}</span>
            });

            columnsTemp.push(averageObjRaw);
            columnsTemp.push(averageObj);

            columnsTemp.push({
                fixed: "right",
                title: <b>Brand Space Score</b>,
                key: "brandSpace",
                align: "center",
                width: 100,
                render: (val, row) => <span className="diff-column" title={row.brandSpace}>{`${(row.brandSpace || 0).toFixed(2)}%`}</span>
            }, {
                fixed: "right",
                title: <b>Whitespace Score</b>,
                key: "diff",
                align: "center",
                width: 100,
                render: (val, row) => <span className="diff-column" title={row.diff}>{`${(row.diff || 0).toFixed(2)}%`}</span>
            });

            Object.keys(generateGrid[0]).forEach((key) => {
                if (["name", "key", "appended", "path", "treekey", "targetSize", "masterSize"].includes(key)) return;
                if (key.includes("_ranked")) return;

                let classText = "";
                const getType = () => {
                    if (key.includes("_brands")) {
                        return "brands";
                    }
                    if (key.includes("_generics")) {
                        return "generics";
                    }
                    return null;
                };
                let nextKey = key.replace("_generics", "").replace("_brands", "").replace("_folder", "");
                const parentID = nextKey.split("~~")[1];
                nextKey = nextKey.replace(`~~${parentID}`, "");
                const type = getType();
                if (type === "brands") {
                    classText = "brands-column";
                }
                if (type === "generics") {
                    classText = "generics-column";
                }
                const colObj = {
                    title: (<Tooltip
                        placement="bottom"
                        title={nextKey}
                    >
                        <span style={{
                            display: "block", whiteSpace: "nowrap", textOverflow: "ellipsis", overflow: "hidden", padding: "0 2mm", cursor: "pointer"
                        }}
                        >
                            {key.includes("_folder") && <FolderFilled style={folderStyle} />}
                            {nextKey}
                        </span>
                    </Tooltip>),
                    key,
                    width: 100,
                    align: "center",
                    render: (val, row) => <span className={classText} title={row[key]}>{(row[key] || 0).toFixed(2)}</span>
                };

                let rankedKey = `${key}_ranked`;
                if (key.includes("~~parent")) {
                    rankedKey = `${key.replace(`~~${parentID}`, "")}_ranked~~${parentID}`;
                }
                const colObj1 = {
                    title: (<Tooltip
                        placement="bottom"
                        title={nextKey}
                    >
                        <span style={{
                            display: "block",
                            whiteSpace: "nowrap",
                            textOverflow: "ellipsis",
                            overflow: "hidden",
                            padding: "0 2mm",
                            cursor: "pointer"
                        }}
                        >
                            {key.includes("_folder") && <FolderFilled style={folderStyle} />}
                            {nextKey}
                        </span>
                    </Tooltip>),
                    key: rankedKey,
                    width: 100,
                    align: "center",
                    render: (val, row) => <span className={classText} title={row[rankedKey]}>{(row[rankedKey] || 0).toFixed(2)}</span>
                };
                if (type === "brands") {
                    if (key.includes("_folder")) {
                        brandcols.children.unshift(colObj);
                    } else {
                        brandcols.children.push(colObj);
                    }
                    if (key.includes("_folder")) {
                        brandcols_ranked.children.unshift(colObj1);
                    } else {
                        brandcols_ranked.children.push(colObj1);
                    }
                }
                if (type === "generics") {
                    genericscols.children.push(colObj);
                    genericscols_ranked.children.push(colObj1);
                }
            });
            if (brandcols_ranked.children.length) { brandcols_ranked.children[0].className = "bodered-col"; }
            if (genericscols.children.length) { genericscols.children[0].className = "bodered-col"; }
            if (genericscols_ranked.children.length) { genericscols_ranked.children[0].className = "bodered-col"; }
            setColumns(columnsTemp);
            setDisplayData(generateGrid);
            setExpandedKeys(generateGrid.map((d) => d.key));

            dispatch(setWhitespaceSegmentSizes([...generateGrid].reduce((acc, data) => {
                acc[data.path] = data.segmentSize;
                data.children.forEach((d) => {
                    acc[d.path] = d.segmentSize;
                });
                return acc;
            }, {})));
        } else {
            setColumns([]);
            setDisplayData([]);
            setExpandedKeys([]);
            dispatch(setWhitespaceSegmentSizes({}));
        }
        dispatch(clearWhiteSpaceChartPDF());
    }, [generateGrid]);
    // }, [whitespaceObj, generateGrid, masterSize]);

    const runLoadingCharts = () => {
        setDisabledDownload(true);
        setIsLoadingCharts(true);
        setTimeout(() => {
            setIsLoadingCharts(false);
        }, 100);
    };

    return (
        <CustomLayout
            className="report--GenerateGrid"
            classNameHeader="report--GenerateGrid--header"
            classNameBody="report--GenerateGrid--body d-flex-col flex-1 gap-5p"
            style={{ width: "100%", height: "100%" }}
            header=""
        >
            {reportIsLoading ? <TableSkeleton noCheckbox cols={10} /> : (
                <>
                    <div style={{ height: "9mm" }} className="d-flex justify-content-between">
                        <Breadcrumb>
                            <Breadcrumb.Item>
                                <Button
                                    className="c-bg-400"
                                    type="link"
                                    style={{ padding: 0 }}
                                    icon={<ArrowLeftOutlined />}
                                    onClick={() => {
                                        dispatch(setGenerateGridData([]));
                                    }}
                                >
                                    Back to Exploration Zone
                                </Button>
                            </Breadcrumb.Item>
                            {breadItems.map((obj, idx) => {
                                if (breadItems.length - 1 === idx) {
                                    return <Breadcrumb.Item key={obj.key}>
                                        <span className="c-bg-700 fw-500 fs-16">
                                            {obj.title}
                                        </span>
                                    </Breadcrumb.Item>
                                }
                                return <Breadcrumb.Item key={obj.key}>
                                    <Button
                                        className="c-bg-400"
                                        style={{ padding: 0 }}
                                        type="link"
                                        onClick={obj.onClick}
                                    >
                                        {obj.title}
                                    </Button>
                                </Breadcrumb.Item>
                            })}
                        </Breadcrumb>

                        <div className="d-flex gap-1">
                            {accessShowZero() && (showVisualMode !== "grid" || isClient) && (
                                <div className="d-flex align-items-center gap-1">
                                    <div className="fw-400 fs-12 c-bg-500 flex-1">Display Contested/Saturated Spaces</div>
                                    <Switch
                                        disabled={disabledDownload || downloading}
                                        size="small"
                                        checked={showZeroInChart}
                                        onChange={(e) => {
                                            setShowZeroInChart(e);
                                            runLoadingCharts();
                                        }}
                                    />
                                </div>
                            )}
                            {showVisualMode === "summary" && (
                                <Button
                                    type="link"
                                    onClick={() => {
                                        if (showVisualMode !== "grid") {
                                            runLoadingCharts();
                                        }
                                        setShowVisualMode("charts");
                                        chartsBreadPushObj();
                                    }}
                                >
                                    Advanced Analysis
                                </Button>
                            )}
                            {showVisualMode !== "grid" && (
                                <Dropdown
                                    disabled={disabledDownload || downloading}
                                    menu={{
                                        onClick: async ({ key }) => {
                                            if (key === "summarycsv") {
                                                downloadSummaryCSV()
                                                return
                                            }
                                            setDownloading(true);
                                            const prms = [...Array.from(chartRef.current.querySelectorAll(".whitespace-chartItem")),
                                            chartRef.current.querySelector(".whitespace-summary")].map((el) => domtoimage.toPng(el)
                                                .then((dataUrl) => ({
                                                    imgURI: dataUrl,
                                                    width: el.getBoundingClientRect().width,
                                                    height: el.getBoundingClientRect().height,
                                                    name: el.getAttribute("name")
                                                }))
                                                .catch((error) => {
                                                    console.error("oops, something went wrong!", error);
                                                    return {
                                                        error: true
                                                    };
                                                }));

                                            const PDFData = await Promise.all(prms);

                                            let pdf = new jsPDF({
                                                format: "a4"
                                            });
                                            const pdfHeight = pdf.internal.pageSize.getHeight();
                                            const pdfWidth = pdf.internal.pageSize.getWidth();
                                            let currenY = 10;

                                            const downloadCSV = (filename, src) => {
                                                const a = document.createElement("a");
                                                a.href = src;
                                                a.download = filename;
                                                a.click();
                                            };
                                            switch (key) {
                                                case "dlpdf": {
                                                    await Promise.all(PDFData.map((pdfObj) => {
                                                        const {
                                                            width, height, imgURI, error
                                                        } = pdfObj;
                                                        if (error) return Promise.resolve();
                                                        const imgPercent = pdfWidth / width;

                                                        const newImgH = (height * imgPercent) - 10;
                                                        const newImgW = (width * imgPercent) - 10;
                                                        currenY += 5;
                                                        const windowHeight = 1650;
                                                        const pageMinusH = 0;
                                                        if (height > windowHeight) {
                                                            let pageHeight = (windowHeight > height ? height : windowHeight) - pageMinusH;
                                                            const nPages = Math.ceil((height - pageMinusH) / windowHeight);
                                                            const { promise, resolve } = createPromise();
                                                            const cropImage = (page) => {
                                                                if (page >= nPages) return resolve();
                                                                const pageCanvas = document.createElement("canvas");
                                                                const pageCtx = pageCanvas.getContext("2d");
                                                                if (page === nPages - 1 && pageHeight % windowHeight !== 0) {
                                                                    pageHeight %= windowHeight;
                                                                }
                                                                pageCanvas.setAttribute("width", width);
                                                                pageCanvas.setAttribute("height", pageHeight);
                                                                const w = width;
                                                                const h = pageHeight;
                                                                const myImage = new Image();
                                                                myImage.src = imgURI;
                                                                const minusW = 7.5;
                                                                const minusH = 0;
                                                                myImage.setAttribute("width", w - minusW);
                                                                myImage.setAttribute("height", h - minusH);
                                                                pageCtx.fillStyle = "transparent";
                                                                pageCtx.fillRect(0, 0, w - minusW, h - minusH);
                                                                myImage.onload = () => {
                                                                    pageCtx.drawImage(myImage, 0, page * pageHeight, w - minusW, h - minusH, 0, 0, w - minusW, h - minusH);

                                                                    const imgData = pageCanvas.toDataURL("image/png");
                                                                    const newCropH = (pageHeight * imgPercent) - 25;

                                                                    pdf = pdf.addPage("a4", "portrait");
                                                                    currenY = 10;
                                                                    pdf.addImage(imgData, "JPEG", 5, currenY, newImgW, newCropH);
                                                                    currenY += newCropH;
                                                                    cropImage(page + 1);
                                                                };
                                                            };
                                                            cropImage(0);
                                                            return promise;
                                                        } if ((currenY + newImgH) >= pdfHeight) {
                                                            pdf = pdf.addPage("a4", "portrait");
                                                            currenY = 10;
                                                        }

                                                        pdf.addImage(imgURI, "JPEG", 5, currenY, newImgW, newImgH);
                                                        currenY += newImgH;
                                                        return Promise.resolve();
                                                    }));

                                                    const selectedMode = getSelectedAnalysis(mode);
                                                    pdf.save(`${selectedMode.title} Charts.pdf`);
                                                    setDownloading(false);
                                                    break;
                                                }
                                                case "dlpng":
                                                case "dljpeg": {
                                                    const recursive = (idx) => {
                                                        const pdfObj = PDFData[idx];
                                                        if (pdfObj) {
                                                            const {
                                                                imgURI, error, name
                                                            } = pdfObj;
                                                            if (error) {
                                                                setTimeout(() => {
                                                                    recursive(idx + 1);
                                                                }, 100);
                                                                return;
                                                            }
                                                            downloadCSV(`${name}.${key.replace("dl", "")}`, imgURI);
                                                            setTimeout(() => {
                                                                recursive(idx + 1);
                                                            }, 100);
                                                        } else {
                                                            setDownloading(false);
                                                        }
                                                    };
                                                    recursive(0);
                                                    break;
                                                }
                                                default:
                                            }
                                        },
                                        items: actionList.reduce((acc, actionItem) => {
                                            if (actionItem.if.includes(showVisualMode)) {
                                                acc.push(actionItem)
                                            }
                                            return acc
                                        }, [])
                                    }}
                                >
                                    <Button
                                        loading={disabledDownload || downloading}
                                        disabled={disabledDownload || downloading}
                                    >

                                        {(disabledDownload || downloading)
                                            ? downloading ? "Downloading..." : "Preparing Charts..." : <>
                                                <DownloadOutlined style={{ marginRight: "2mm" }} />
                                                {"Download as"}
                                            </>}
                                        <DownOutlined />
                                    </Button>
                                </Dropdown>
                            )}
                            {showVisualMode === "grid" && (
                                <Button
                                    type="primary"
                                    onClick={() => {
                                        if (showVisualMode !== "grid") {
                                            runLoadingCharts();
                                        }
                                        setShowVisualMode("charts");
                                        chartsBreadPushObj();
                                        // setShowVisualMode("summary");
                                        // summaryBreadPushObj();
                                    }}
                                >
                                    Display Charts
                                </Button>
                            )}
                        </div>
                    </div>
                    {showVisualMode === "grid" ? (
                        <CustomTable
                            className="generated-grid"
                            style={{ height: "calc(100% - 10mm)", width: "100%" }}
                            paginationConfig={paginationConfig}
                            columns={columns}
                            expandable={{
                                expandedRowKeys: expandedKeys,
                                onExpand: (e, d) => {
                                    if (e) {
                                        if (!expandedKeys.includes(d.key)) {
                                            setExpandedKeys([...expandedKeys, d.key]);
                                        }
                                    } else {
                                        setExpandedKeys(expandedKeys.filter((k) => k !== d.key));
                                    }
                                },
                                expandIcon: ({ expanded, onExpand, record }) => {
                                    if (!record.children) return <span style={{ padding: "4mm" }} />;
                                    return (expanded ? (
                                        <CaretDownOutlined style={{ margin: "0 2mm" }} onClick={(e) => onExpand(record, e)} />
                                    ) : (
                                        <CaretRightOutlined style={{ margin: "0 2mm" }} onClick={(e) => onExpand(record, e)} />
                                    ));
                                }
                            }}
                            paginationProps={{
                                onChangePagination
                            }}
                            dataSource={displayData}
                            numColProps={{ fixed: "left" }}
                            bordered
                            noCheckbox
                            romanizeParent
                        />
                    ) : showVisualMode === "summary"
                        ? <WhiteSpaceSummaryDisplay
                            loading={isLoadingCharts}
                            setDisabledDownload={setDisabledDownload}
                        />
                        : <WhiteSpaceChartsDisplay
                            loading={isLoadingCharts}
                            showZeroInChart={showZeroInChart}
                            ref={chartRef}
                            setDisabledDownload={setDisabledDownload}
                        />
                    }
                </>
            )}
        </CustomLayout>
    );
}

export default GenerateGrid;
